import {
  CollectionModulePaymentMethod,
  DebitOrderPaymentMethod,
  ExternalPaymentMethod,
  PaymentMethodAll,
} from 'payment-methods/domain/payment-method';
import { Policy } from 'policies/domain/policy';
import React from 'react';
import { ProductModuleDefinitionEmbeddedConfig } from 'site-config';
import { ManageExternalPaymentMethodCard } from './payment-method-display-cards/external-payment-method-card';
import { ManageDebitOrderPaymentMethod } from './payment-method-display-cards/debit-order-payment-method-card';
import { CollectionModulePaymentMethodSummaryView } from './payment-method-display-cards/collection-module-payment-method-summary';

export const PaymentMethodCard = (props: {
  siteConfig: ProductModuleDefinitionEmbeddedConfig | null;
  paymentMethod: PaymentMethodAll;
  policy: Policy;
  refetchPolicy: () => void;
  setShowUpdateBillingDay: (showUpdateBillingDay: boolean) => void;
}) => {
  const { paymentMethod, siteConfig, policy, setShowUpdateBillingDay } = props;

  if (paymentMethod instanceof DebitOrderPaymentMethod) {
    return (
      <ManageDebitOrderPaymentMethod
        paymentMethod={paymentMethod}
        siteConfig={siteConfig}
        policy={policy}
        setShowUpdateBillingDay={setShowUpdateBillingDay}
      />
    );
  }

  if (paymentMethod instanceof ExternalPaymentMethod) {
    return (
      <ManageExternalPaymentMethodCard
        paymentMethod={paymentMethod}
        siteConfig={siteConfig}
        policy={policy}
        setShowUpdateBillingDay={setShowUpdateBillingDay}
      />
    );
  }

  if (paymentMethod instanceof CollectionModulePaymentMethod) {
    return (
      <CollectionModulePaymentMethodSummaryView
        paymentMethod={paymentMethod}
        policy={policy}
        setShowUpdateBillingDay={setShowUpdateBillingDay}
      />
    );
  }

  return <p>Payment method type not yet supported</p>;
};
